
import { Button, Modal } from "react-bootstrap";

const CustomModal=({show,onHide,heading,children})=> {

    return (
      <>
        <Modal
          show={show}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">{heading}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           {children}
          </Modal.Body>
        
        </Modal>
      </>
    );
  }
  
  export default CustomModal;